const ruleRoutes = [
  {
    path: 'rules',
    name: 'Rules',
    component: () => import('./views/RulesListPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new/guided',
    name: 'GuidedRuleCreate',
    component: () => import('./views/GuidedRuleWizardPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new/wizard',
    name: 'WizardRuleCreate',
    component: () => import('./views/RuleWizardPage.vue'),
    props: { mode: 'create' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/new/builder',
    name: 'RuleBuilder',
    component: () => import('./views/RuleBuilderPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/:id/edit',
    name: 'RuleEdit',
    component: () => import('./views/RuleWizardPage.vue'),
    props: route => ({ mode: 'edit', ruleId: route.params.id }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'rules/:id',
    name: 'RuleDetail',
    component: () => import('./views/RuleDetailPage.vue'),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  // Temporary redirects preserve bookmarks while the canonical routes settle.
  {
    path: 'rules/new',
    redirect: { name: 'GuidedRuleCreate' },
  },
  {
    path: 'builder',
    redirect: { name: 'GuidedRuleCreate' },
  },
  {
    path: 'builder/simple',
    redirect: { name: 'WizardRuleCreate' },
  },
  {
    path: 'builder/advanced',
    redirect: { name: 'WizardRuleCreate' },
  },
  {
    path: 'rules/editor/create',
    redirect: { name: 'WizardRuleCreate' },
  },
  {
    path: 'rules/editor/update/:ruleId',
    redirect: route => ({ name: 'RuleEdit', params: { id: route.params.ruleId } }),
  },
]

export default router => {
  ruleRoutes.forEach(route => {
    router.addRoute('AppShell', route)
  })
}
